module.exports = "<button *ngFor=\"let category of categories\" class=\"category-button\">\r\n  {{category.name}}\r\n</button>"